import {
  useDrawerContext,
  type DrawerRootProps,
  DrawerRoot as ChakraDrawerRoot,
  type DrawerBackdropProps,
  DrawerBackdrop as ChakraDrawerBackdrop,
  type DrawerPositionerProps as ChakraDrawerPositionerProps,
  DrawerPositioner as ChakraDrawerPositioner,
  type DrawerContentProps,
  DrawerContent as ChakraDrawerContent,
  type DrawerActionTriggerProps as ChakraDrawerActionTriggerProps,
  DrawerActionTrigger as ChakraDrawerActionTrigger,
} from '@chakra-ui/react/drawer';

export function DrawerRoot({ children, ...props }: DrawerRootProps) {
  return (
    <ChakraDrawerRoot
      modal={false}
      lazyMount
      unmountOnExit
      {...props}
      restoreFocus={false}
      trapFocus={false}
      closeOnInteractOutside={false}
    >
      {children}
    </ChakraDrawerRoot>
  );
}

export function DrawerBackdrop({ children, ...props }: DrawerBackdropProps) {
  return (
    <ChakraDrawerBackdrop pos="absolute" boxSize="full" {...props}>
      {children}
    </ChakraDrawerBackdrop>
  );
}

export interface DrawerPositionerProps extends ChakraDrawerPositionerProps {
  closeOnInteractOutside?: boolean;
}

export function DrawerPositioner({
  children,
  onMouseDown,
  closeOnInteractOutside = true,
  ...props
}: DrawerPositionerProps) {
  const { setOpen } = useDrawerContext();
  return (
    <ChakraDrawerPositioner
      pos="absolute"
      boxSize="full"
      p="0"
      {...props}
      onMouseDown={(...args) => {
        if (closeOnInteractOutside) {
          setOpen(false);
        }
        onMouseDown?.(...args);
      }}
    >
      {children}
    </ChakraDrawerPositioner>
  );
}

export function DrawerContent({ children, onMouseDown, ...props }: DrawerContentProps) {
  return (
    <ChakraDrawerContent
      {...props}
      onMouseDown={(e, ...args) => {
        e.stopPropagation();
        onMouseDown?.(e, ...args);
      }}
    >
      {children}
    </ChakraDrawerContent>
  );
}

export interface DrawerActionTriggerProps extends ChakraDrawerActionTriggerProps {
  disabled?: boolean;
}

export function DrawerActionTrigger({ children, disabled, ...props }: DrawerActionTriggerProps) {
  if (disabled) {
    return children;
  }
  return <ChakraDrawerActionTrigger {...props}>{children}</ChakraDrawerActionTrigger>;
}
